import styled, { CSSObject } from '@emotion/styled';
import merge from 'lodash.merge';

import { ButtonLinkColor, ButtonLinkSize } from './constants';

interface IStyledButtonLinkProps {
  color: ButtonLinkColor;
  size: ButtonLinkSize;
}

export const StyledButtonLink = styled.button<IStyledButtonLinkProps>(({ color, size }) => {
  let styles: CSSObject = {
    display: 'inline-block',
    outline: 'none',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
    flexShrink: 0,
    wordBreak: 'break-all',
    ':disabled': {
      opacity: 0.3,
      cursor: 'default',
    },
  };

  if (color === ButtonLinkColor.PRIMARY) {
    const primaryStyles: CSSObject = {
      color: 'rgba(0, 178, 120, 1)',
      ':hover': { color: 'rgba(0, 108, 73, 1)' },
      ':active': { color: 'rgba(0, 108, 73, 1)' },
    };

    styles = merge(styles, primaryStyles);
  }

  if (color === ButtonLinkColor.SECONDARY) {
    const secondaryStyles: CSSObject = {
      color: 'rgba(10, 11, 12, 1)',
      ':hover': { color: 'rgba(120, 120, 120, 1)' },
      ':active': { color: 'rgba(120, 120, 120, 1)' },
    };

    styles = merge(styles, secondaryStyles);
  }

  if (color === ButtonLinkColor.DANGER) {
    const dangerStyles: CSSObject = {
      color: 'rgba(224, 54, 0, 1)',
      ':hover': { color: 'rgba(167, 40, 0, 1)' },
      ':active': { color: 'rgba(167, 40, 0, 1)' },
    };

    styles = merge(styles, dangerStyles);
  }

  if (size === ButtonLinkSize.SMALL) {
    const smallStyles: CSSObject = {
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '1.5em',
    };

    styles = merge(styles, smallStyles);
  }

  if (size === ButtonLinkSize.MEDIUM) {
    const mediumStyles: CSSObject = {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '1.5em',
    };

    styles = merge(styles, mediumStyles);
  }

  if (size === ButtonLinkSize.LARGE) {
    const largeStyles: CSSObject = {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '1.5em',
    };

    styles = merge(styles, largeStyles);
  }

  return styles;
});
